import { Injectable } from '@angular/core';
import { GlobalService } from '@common/global';
import { ApiService } from '@services/api.service';
import { HttpParams } from '@angular/common/http'
@Injectable({
  providedIn: 'root'
})
export class MemberService {

  constructor(private _global: GlobalService, private api: ApiService) { }
  login(obj) {
    let params = new HttpParams();
    params = params.append('siteId', this._global.SITEID);
    params = params.append('orgId', this._global.ORGID);
    params = params.append('domainName', this._global.DOMAIN_NAME);
    params = params.append('sess_cookie', this._global.getToken());
    params = params.append('token', this._global.getToken());
   
    Object.entries(obj).forEach(([key, value]) => {
      let v = obj[key];
      if (key == 'component') {
        params = params.append(key, this._global.getComponent(v));
      } else {
        params = params.append(key, v);
      }
    });
    return this.api.call('member/login',params);
  }
  register(obj) {
    let params = new HttpParams();
    params = params.append('siteId', this._global.SITEID);
    params = params.append('orgId', this._global.ORGID);
    params = params.append('domainName', this._global.DOMAIN_NAME);
    params = params.append('sess_cookie', this._global.getToken());
    params = params.append('token', this._global.getToken());
   
    Object.entries(obj).forEach(([key, value]) => {
      let v = obj[key];
        params = params.append(key, v);
    });
    return this.api.call('member/register',params);
  }
  duplicate(obj) {
    let params = new HttpParams();
    params = params.append('siteId', this._global.SITEID);
    params = params.append('orgId', this._global.ORGID);
    params = params.append('domainName', this._global.DOMAIN_NAME);
    params = params.append('sess_cookie', this._global.getToken());
    params = params.append('token', this._global.getToken());
   
    Object.entries(obj).forEach(([key, value]) => {
      let v = obj[key];
        params = params.append(key, v);
    });
    return this.api.call('member/duplicate',params);
  }
  passwordResetEmail(obj) {
    let params = new HttpParams();
    params = params.append('component', this._global.COMPONENTS_SMN);
    params = params.append('siteId', this._global.SITEID);
    params = params.append('orgId', this._global.ORGID);
    params = params.append('domainName', this._global.DOMAIN_NAME);
    params = params.append('sess_cookie', this._global.getToken());
    params = params.append('token', this._global.getToken());
    params = params.append('captchaType', 'mfs');
    params = params.append('isMember', 'true');
    params = params.append('application', 'member');
   
    Object.entries(obj).forEach(([key, value]) => {
      let v = obj[key];
        params = params.append(key, v);
    });
    return this.api.call('reset/create',params);
  }
  logout(obj) {
    let params = new HttpParams();
    params = params.append('siteId', this._global.SITEID);
    params = params.append('orgId', this._global.ORGID);
    params = params.append('domainName', this._global.DOMAIN_NAME);
    params = params.append('sess_cookie', this._global.getToken());
    params = params.append('token', this._global.getToken());
   
    return this.api.call('member/logout',params);
  }
  activities(obj) {
    let params = new HttpParams();
    params = params.append('siteId', this._global.SITEID);
    params = params.append('orgId', this._global.ORGID);
    params = params.append('domainName', this._global.DOMAIN_NAME);
    params = params.append('sess_cookie', this._global.getToken());
    params = params.append('token', this._global.getToken());
   
    Object.entries(obj).forEach(([key, value]) => {
      let v = obj[key];
      if (key == 'component') {
        params = params.append(key, this._global.getComponent(v));
      } else {
        params = params.append(key, v);
      }
    });
    return this.api.call('member/search/activities',params.toString());
  }
}